import {
  Grid,
  Theme,
  Typography,
  Divider,
  Button,
  Box,
  Stack,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import footerLogo from '../../assets/imgs/ariginalFishTacos.png';
import andriodLogo from '../../assets/imgs/button-google.png';
import iosLogo from '../../assets/imgs/button-apple.png';
import FooterBg from '../../assets/imgs/BottomBG.png';
import { useDispatch, useSelector } from 'react-redux';
import { getMenuRequest } from '../../redux/actions/footer';
import { externalLinkProps } from '../../helpers/common';
import { useEffect } from 'react';
import './footer.css';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';
import instaIcon from '../../assets/imgs/insta-icon.png';
import tiktokIcon from '../../assets/imgs/tik-tok.png';

const useStyles = makeStyles((theme: Theme) => ({
  links: {
    textTransform: 'uppercase',
    fontSize: '1rem',
    fontFamily: "'Sunborn-Sansone' !important",
    textDecoration: 'none',
    color: '#fff',
    fontWeight: 400,
    letterSpacing: '1.00938px',
    '&:hover': {
      color: theme.palette.success.main,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
    },
  },
  smallLinks: {
    color: '#fff',
    fontSize: '13px',
    textAlign: 'center',

    fontiWeight: 500,

    fontFamily: 'Libre-Franklin, sans-serif !important',
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.success.main,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
      textAlign: 'left',
      overflowWrap: 'break-word',
    },
  },
  list: {
    listStyle: 'none',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: ' auto auto auto auto auto auto auto',
  },
}));

const Footer = () => {
  const classes = useStyles();
  const menu = useSelector((state: any) => state.footerReducer.menu);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMenuRequest());
  }, []);

  useEffect(() => {}, [menu]);

  return (
    <footer
    // className={`${
    //   window.location.href.toLocaleLowerCase().includes('/product')
    //     ? 'footer-control'
    //     : 'footer-setting'
    // }`}
    >
      <Grid
        container
        spacing={0}
        sx={{
          display: 'flex',
          backgroundImage: `url(${FooterBg})`,
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
          margin: 0,
          padding: {
            xs: '1.9rem 1rem',
            md: '2.5rem 4.4rem 1.3rem 4.4rem',
          },
           '@media (max-width:399px)': {
            paddingLeft: '11px',
            paddingRight: '11px',
          },
          minHeight: {
            xs: '26rem',
            sm: '16.6rem',
          },
        }}
      >
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            width: '100%',
            gap: 2,
          }}
        >
          {/* Logo */}
          <Box sx={{ flex: '0 0 auto', mb: { xs: 2, md: 0 } }}>
            <Button
              component="a"
              href={process.env.REACT_APP_RUBIOS_HOME_PAGE || ''}
              {...externalLinkProps(process.env.REACT_APP_RUBIOS_HOME_PAGE)}
              sx={{ p: 0, display: 'flex', alignItems: 'center' }}
            >
              <Box
                component="img"
                src={footerLogo}
                alt="Rubios Coastal Grill"
                title="Rubios Coastal Grill"
                sx={{
                  cursor: 'pointer',
                  width: { xs: '5.6rem', sm: '7.5rem', md: '8.1rem' },
                  height: 'auto',
                }}
              />
            </Button>
          </Box>

          {/* Right side */}
          <Box
            sx={{
              flex: '1 1 0',
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 2,
            }}
          >
            {/* Menu Links */}
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: {
                  xs: 'flex-start',
                  sm: 'flex-start',
                  md: 'flex-start',
                  lg: 'flex-end',
                },
                gap: 2,
                width: '100%',
              }}
            >
              {menu?.items.map((item: any, index: number) => (
                <Box
                  key={index}
                  sx={{ whiteSpace: 'nowrap', flex: '0 0 auto' }}
                >
                  <a
                    href={item.url}
                    {...externalLinkProps(item.url)}
                    title={item.title}
                    className={classes.links}
                  >
                    {item.title}
                  </a>
                </Box>
              ))}
            </Box>

            {/* Social + App Store (same row) */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: {
                  xs: 'flex-start',
                  sm: 'space-between',
                  md: 'flex-end',
                },
                gap: 2,
                flexWrap: 'wrap',
                width: '100%',
                alignItems: 'center',
                mt: 1,
              }}
            >
              {/* Social icons */}

              <Stack flexDirection="row" gap="22px">
                <Box
                  sx={{
                    paddingTop: { xs: '30px' },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '12px',
                      color: '#fff',
                      textTransform: 'uppercase',
                      fontFamily: "'Sunborn-Sansone'!important",
                      fontWeight: 400,
                    }}
                    title="Connect with Us"
                    role="heading"
                    aria-level={2}
                  >
                    Connect with Us
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'start',
                      gap: '12px',
                      alignItems: 'center',
                      marginTop: '11px',
                    }}
                  >
                    <a
                      href={'https://www.instagram.com/rubioscoastalgrill/'}
                      target={'_blank'}
                      aria-label="Visit our Instagram page."
                      rel="noreferrer"
                    >
                      <img
                        src={instaIcon}
                        style={{ width: '18px', height: 'auto' }}
                        alt="Instagram Icon"
                      />
                    </a>
                    <a
                      aria-label="Visit our Facebook page."
                      href={'https://www.facebook.com/rubioscoastalgrill'}
                      target={'_blank'}
                      rel="noreferrer"
                    >
                      <FacebookOutlinedIcon
                        style={{
                          color: 'white',
                          width: '20px',
                          height: 'auto',
                        }}
                      />
                    </a>
                    <a
                      aria-label="Visit our Twitter page."
                      href={'https://twitter.com/RubiosTweets'}
                      target={'_blank'}
                      rel="noreferrer"
                    >
                      <TwitterIcon
                        style={{
                          color: 'white',
                          width: '20px',
                          height: 'auto',
                          // marginLeft: '5px',
                        }}
                      />
                    </a>
                    <a
                      aria-label="Visit our Tiktok page."
                      href={'https://www.tiktok.com/@officialrubios'}
                      target={'_blank'}
                      rel="noreferrer"
                    >
                      <img
                        src={tiktokIcon}
                        style={{ width: '18px', height: 'auto' }}
                        alt="Tiktok Icon"
                      />
                    </a>
                  </Box>
                </Box>
                <Box sx={{ marginRight: { xs: 0 } }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      color: '#fff',
                      textTransform: 'uppercase',
                      fontFamily: "'Sunborn-Sansone'!important",
                      paddingTop: { xs: '30px' },
                      fontWeight: 400,
                    }}
                    title="Get The Rubio's App"
                  >
                    Get The Rubio's App
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'start',
                      marginTop: '11px',
                      alignItems: 'center',
                      gap: '12px',
                      ml: 'auto',
                    }}
                  >
                    <a
                      href={process.env.REACT_APP_IOS_DOWNLOAD_LINK}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        style={{
                          display: 'inline-block',
                          width: '102px',
                          height: '30px',
                        }}
                        src={iosLogo}
                        alt="Click Here To Download Our From Apple Store"
                      />
                    </a>
                    <a
                      href={process.env.REACT_APP_GOOGLE_DOWNLOAD_LINK}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        style={{
                          display: 'inline-block',
                          width: '102px',
                          height: '30px',
                        }}
                        src={andriodLogo}
                        alt="Click Here To Download Our From Google App Store"
                      />
                    </a>
                  </Box>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Box>

        {/* for mobile only */}
        <Box
          sx={{
            display: { xs: 'flex', md: 'none' },
            flexDirection: { xs: 'row', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            gap: { xs: 1, sm: 2 },
          }}
        >
          {/* Logo / Button */}
          <Box sx={{ flex: '0 0 auto', mb: { xs: 2, md: 0 } }}>
            <Button
              component="a"
              href={process.env.REACT_APP_RUBIOS_HOME_PAGE || ''}
              {...externalLinkProps(process.env.REACT_APP_RUBIOS_HOME_PAGE)}
              sx={{ p: 0, minWidth: 0, display: 'flex', alignItems: 'center' }}
            >
              <Box
                component="img"
                src={footerLogo}
                alt="Rubios Coastal Grill"
                title="Rubios Coastal Grill"
                sx={{
                  cursor: 'pointer',
                  width: { xs: '5.6rem', sm: '7.5rem', md: '8.1rem' },
                  height: 'auto',
                }}
              />
            </Button>
          </Box>

          {/* Menu Links */}
          <Box
            sx={{
              flex: '1 1 0',
              minWidth: 0,
              display: 'grid',
              gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
             gap: '6px',
            '@media (min-width:400px)': {
              gap: '16px',
            },
              width: '100%',
            }}
          >
            {menu?.items.map((item: any, index: number) => (
              <Box
                key={index}
                sx={{
                  minWidth: 0,
                  whiteSpace: 'normal',
                  overflowWrap: 'break-word',
                }}
              >
                <a
                  href={item.url}
                  {...externalLinkProps(item.url)}
                  title={item.title}
                  className={classes.links}
                >
                  {item.title}
                </a>
              </Box>
            ))}
          </Box>
        </Box>

        <Stack
          flexDirection="row"
          flexWrap="wrap"
          sx={{
            display: { xs: 'flex', md: 'none' },
            justifyContent: { xs: 'space-between', sm: 'space-evenly' },
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            columnGap: 1,
            rowGap: 2,
          }}
        >
          <Box
            sx={{
              paddingTop: { xs: '30px' },
            }}
          >
            <Typography
              sx={{
                fontSize: '12px',
                color: '#fff',
                textTransform: 'uppercase',
                fontFamily: "'Sunborn-Sansone'!important",
                fontWeight: 400,
              }}
              title="Connect with Us"
              role="heading"
              aria-level={2}
            >
              Connect with Us
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'start',
                gap: '12px',
                alignItems: 'center',
                marginTop: '11px',
              }}
            >
              <a
                href={'https://www.instagram.com/rubioscoastalgrill/'}
                target={'_blank'}
                aria-label="Visit our Instagram page."
                rel="noreferrer"
              >
                <img
                  src={instaIcon}
                  style={{ width: '18px', height: 'auto' }}
                  alt="Instagram Icon"
                />
              </a>
              <a
                aria-label="Visit our Facebook page."
                href={'https://www.facebook.com/rubioscoastalgrill'}
                target={'_blank'}
                rel="noreferrer"
              >
                <FacebookOutlinedIcon
                  style={{ color: 'white', width: '20px', height: 'auto' }}
                />
              </a>
              <a
                aria-label="Visit our Twitter page."
                href={'https://twitter.com/RubiosTweets'}
                target={'_blank'}
                rel="noreferrer"
              >
                <TwitterIcon
                  style={{
                    color: 'white',
                    width: '20px',
                    height: 'auto',
                    // marginLeft: '5px',
                  }}
                />
              </a>
              <a
                aria-label="Visit our Tiktok page."
                href={'https://www.tiktok.com/@officialrubios'}
                target={'_blank'}
                rel="noreferrer"
              >
                <img
                  src={tiktokIcon}
                  style={{ width: '18px', height: 'auto' }}
                  alt="Tiktok Icon"
                />
              </a>
            </Box>
          </Box>
          <Box sx={{ marginRight: { xs: 0 }, minWidth: 0, maxWidth: '100%' }}>
            <Typography
              sx={{
                fontSize: '12px',
                color: '#fff',
                textTransform: 'uppercase',
                fontFamily: "'Sunborn-Sansone'!important",
                paddingTop: { xs: '30px' },
                fontWeight: 400,
              }}
              title="Get The Rubio's App"
            >
              Get The Rubio's App
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'start',
                marginTop: '11px',
                alignItems: 'center',
                gap: { xs: '8px', sm: '12px' },
                ml: 'auto',
                flexWrap: 'wrap',
              }}
            >
              <a
                href={process.env.REACT_APP_IOS_DOWNLOAD_LINK}
                target="_blank"
                rel="noreferrer"
              >
                <Box
                  component="img"
                  sx={{
                    display: 'inline-block',
                    width: { xs: '88px', sm: '102px' },
                    height: '30px',
                  }}
                  src={iosLogo}
                  alt="Click Here To Download Our From Apple Store"
                />
              </a>
              <a
                href={process.env.REACT_APP_GOOGLE_DOWNLOAD_LINK}
                target="_blank"
                rel="noreferrer"
              >
                <Box
                  component="img"
                  sx={{
                    display: 'inline-block',
                    width: { xs: '88px', sm: '102px' },
                    height: '30px',
                  }}
                  src={andriodLogo}
                  alt="Click Here To Download Our From Google App Store"
                />
              </a>
            </Box>
          </Box>
        </Stack>
        <Grid
          item
          xs={12}
          sx={{
            paddingTop: { xs: '30px', md: '40px', lg: '40px' },
            paddingBottom: { xs: '30px', md: '20px' },
            maxWidth: '100%',
          }}
        >
          <Divider
            color="#fff"
            sx={{
              margin: { xs: 0, md: '0 -4.4rem' },
              borderWidth: '1px',
            }}
          />
        </Grid>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={{ xs: 'flex-start', md: 'space-between' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={{ xs: 3, md: 0 }}
          width="100%"
          sx={{ maxWidth: '100%', minWidth: 0 }}
        >
          <Box sx={{ minWidth: 0, maxWidth: '100%' }}>
            <Typography
              sx={{
                fontSize: { xs: '11px', sm: '13px' },
                fontWeight: 500,
                fontFamily: 'Libre-Franklin, sans-serif !important',
                paddingBottom: { xs: '30px', sm: 0 },
                whiteSpace: { xs: 'normal', md: 'nowrap' },
              }}
              variant="caption"
              color="#fff"
              title="© 2026 Rubio’s Restaurants, Inc. All Rights reserved."
            >
              © 2026 Rubio’s Restaurants, Inc. All Rights reserved.
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
              flexWrap: 'wrap',
              columnGap: { xs: '16px', sm: '22px' },
              rowGap: { xs: '8px', md: 0 },
              width: { xs: '100%', md: 'auto' },
              maxWidth: '100%',
              minWidth: 0,
            }}
          >
            {[
              {
                label: 'Terms of Use',
                href: process.env.REACT_APP_TERMS_LINK,
              },
              {
                label: 'Privacy',
                href: process.env.REACT_APP_PRIVACY_LINK,
              },
              {
                label: 'Cookies',
                href: 'javascript:Optanon.ToggleInfoDisplay()',
              },
              {
                label: 'Website Accessibility',
                href: process.env.REACT_APP_WEBSITE_ACCESSIBILITY_LINK,
              },
              {
                label: 'Do Not Sell My Personal Information',
                href: 'javascript:Optanon.ToggleInfoDisplay()',
              },
            ].map((item, index) => (
              <Box key={index} sx={{ minWidth: 0, maxWidth: '100%' }}>
                <a
                  href={item.href}
                  {...externalLinkProps(item.href)}
                  className={classes.smallLinks}
                  title={item.label}
                  aria-label={item.label}
                >
                  {item.label}
                </a>
              </Box>
            ))}
          </Box>
        </Stack>
      </Grid>
    </footer>
  );
};

export default Footer;
